export class RecentStudent {  
    RecentCreatedDate:any;
    Data:any=[];
}